module.exports = __webpack_public_path__ + "img/mtt_4.5.c19accc2.png";